var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonuced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9512 2.5C6.67789 2.5 3.20117 5.97672 3.20117 10.25C3.20117 14.5233 6.67789 18 10.9512 18C15.2245 18 18.7012 14.5233 18.7012 10.25C18.7012 5.97672 15.2245 2.5 10.9512 2.5ZM5.13867 10.25C5.13867 8.99661 5.54145 7.83776 6.2187 6.8874L14.3138 14.9825C13.3634 15.6597 12.2046 16.0625 10.9512 16.0625C7.74598 16.0625 5.13867 13.4552 5.13867 10.25ZM15.6836 13.6126L7.58854 5.51753C8.53891 4.84028 9.69775 4.4375 10.9511 4.4375C14.1563 4.4375 16.7636 7.0448 16.7636 10.25C16.7636 11.5034 16.3609 12.6622 15.6836 13.6126Z",
    fill: "#F96056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonuced);
export default __webpack_public_path__ + "static/media/bonuced.96738c45125a6138eeee8067a20e7204.svg";
export { ForwardRef as ReactComponent };